import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import CustomVideoPlayer from '../../../src/components/custom-video-player';
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/494d440c-98d2-4634-beec-8a80caca8926",
        "alt": "An image showing a card with a Copilot Octicon."
      }}></img></p>
    <h2>{`Usage`}</h2>
    <p>{`Use cards to summarize the central idea behind some content and provide a link to its corresponding detailed resource. It is important to present the information in a concise manner, avoiding lengthy and complex descriptions.`}</p>
    <p>{`Cards should always be used in groups of two or more related concepts.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/d0da491e-8895-4ba2-9840-17eef7f2dd75" />
    <Caption mdxType="Caption">Use cards in groups to display related information.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/9f17706e-dfb1-4ef9-a87d-df6c8a1d3825" />
    <Caption mdxType="Caption">
      Don't use isolated cards. Consider using a CTABanner instead.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Stacked`}</h3>
    <p>{`Cards should be stacked to display a list of items that are related to each other. If displaying a visual asset, do so for all cards to achieve a visually balanced layout. The visual asset should be the same type for all cards, either an icon or an image.`}</p>
    <p>{`For a better visual experience, we recommend using similar length size for the heading and description in all stacked cards.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/fced572e-c296-4a97-aaa8-3d4b357f2f6e" />
    <Caption mdxType="Caption">
      Use the same type of visual asset for all cards and a similar length size
      for the content.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/c612ccf8-7c98-4213-92b9-2fdf6f0f1398" />
    <Caption mdxType="Caption">
      Don't use different length sizes for the title or the description.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`When using an image as the visual asset, we recommend using the same aspect ratio for all images. This will create a more balanced visual experience.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/0ec93c16-7091-4ebb-a1a0-b0626de7833f" />
    <Caption mdxType="Caption">
      Use the same image ratio and a similar length sizes for the content.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/0b8ffb2d-0753-4bdd-9165-0f30ec28a8c8" />
    <Caption mdxType="Caption">
      Don't use different image ratios and a different length size for the
      content.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Cards typically appear in groups of three or four in desktop viewports. For smaller viewports, or when more than four cards are needed, we recommend stacking the cards vertically. You can use the `}<a parentName="p" {...{
        "href": "/components/Grid"
      }}>{`Grid`}</a>{` or the `}<a parentName="p" {...{
        "href": "/components/Stack"
      }}>{`Stack`}</a>{` component to achieve this.`}</p>
    <div>
  <CustomVideoPlayer width="100%" src="https://github.com/primer/brand/assets/912236/d8e76477-1b27-4be1-9bf5-d22186af8376" mdxType="CustomVideoPlayer" />
  <Caption mdxType="Caption">
    Stack cards vertically so that the content has enough line length.
  </Caption>
    </div>
    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/633b83d8-4ea8-49bd-9d6c-45a1989060d9",
        "alt": "An image showing the card anatomy with an icon as a visual asset, a heading, a description and a CTA text in a vertical order."
      }}></img></p>
    <h3>{`Visual asset`}</h3>
    <p>{`The visual asset is optional and can be an image or an icon. It can be used to provide a visual cue to the user about the content of the card. To avoid visual noise, we recommend using only one icon or image, but not both in the same card.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/be65583b-f6f0-438a-8d2c-6b7a0a9fd3de",
        "alt": "An image showing two cards, one with an Icon and another with an Image as the visual assets options."
      }}></img></p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/863de864-5216-44bf-8b35-430821da8853" />
    <Caption mdxType="Caption">Use only one visual asset per card.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/9acdde97-42e3-4a7a-8102-b9be5e3c05fc" />
    <Caption mdxType="Caption">Don't use both icon and image as the visual asset.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Label`}</h3>
    <p>{`The label can be used to indicate the type of content or its status. For example, use it to indicate that the content is `}<inlineCode parentName="p">{`new`}</inlineCode>{` or that it is a `}<inlineCode parentName="p">{`beta`}</inlineCode>{` feature. The label is optional and can be used along with a visual asset.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/2d84fe89-2735-451e-9d1f-9a2f0297e7b5",
        "alt": "An image showing two cards, one with a Label and another one with Label and Icon."
      }}></img></p>
    <h3>{`Heading`}</h3>
    <p>{`The heading is the main title of the card. It should be short and concise.`}</p>
    <h3>{`Description`}</h3>
    <p>{`The description is an optional short text that extends the information provided by the heading.`}</p>
    <h3>{`Call to action`}</h3>
    <p>{`The call to action label indicates the action or resource the card links to. It defaults to "Learn more".`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Pillar"
        }}>{`Pillar`}</a>{`: To display related content with less visual emphasis.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/River"
        }}>{`River`}</a>{`: To display a list of content items with a visual asset.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/CTABanner"
        }}>{`CTABanner`}</a>{`: To display a single block of content to draw attention or create urgency around a user action.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/UnorderedList"
        }}>{`UnorderedList`}</a>{` or the `}<a parentName="li" {...{
          "href": "/components/OrderedList"
        }}>{`OrderedList`}</a>{`: to display a list of plain content items.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      